import useGetCurrentsTools from "./useGetCurrentsTools.js";

const useGetCurrentTypeCol = () => {

  const getCurrentsTools = useGetCurrentsTools();
  
  const getCurrentTypeCol = (updatedFormData, currentToolIds, dataGridId, type) => {
    var dataGrid = []
    getCurrentsTools(updatedFormData, dataGrid, [dataGridId]);
    
    const currentColIds = dataGrid[0].metaData.filter(item=>  item.type == type)[0].metaData
      .filter(item=> item.headerId == currentToolIds[0]).map(item=> item.id);
    
    return currentColIds[0]
  }
  

  return getCurrentTypeCol;
};

export default useGetCurrentTypeCol;
